// AppSettings context — provides global app title
import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { getSettings } from '../services/api';

interface AppSettingsContextValue {
  appTitle: string;
  setAppTitle: (title: string) => void;
}

const AppSettingsContext = createContext<AppSettingsContextValue>({
  appTitle: 'CM-Monitor',
  setAppTitle: () => {},
});

export function AppSettingsProvider({ children }: { children: ReactNode }) {
  const [appTitle, setAppTitle] = useState('CM-Monitor');

  useEffect(() => {
    getSettings()
      .then((s) => {
        if (s.appTitle) setAppTitle(s.appTitle);
      })
      .catch(() => {
        // keep default on auth failure (e.g. login page)
      });
  }, []);

  // Sync browser tab title with app title (FR-011)
  useEffect(() => {
    document.title = appTitle;
  }, [appTitle]);

  return (
    <AppSettingsContext.Provider value={{ appTitle, setAppTitle }}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings() {
  return useContext(AppSettingsContext);
}
